import { createFileRoute } from '@tanstack/react-router';
import { CsatSurveyPage } from '@/features/public/components/CsatSurveyPage';

/**
 * Public CSAT survey page. Sat at the top level of /routes (not under
 * `_auth/`) so it bypasses the auth gate — the customer who clicks this
 * link from WhatsApp/email/SMS isn't logged in.
 *
 * Backend endpoint validates the capability and returns 400 / 404 / 410 for
 * invalid / missing / answered or expired surveys; the page surfaces the
 * appropriate copy without ever touching the auth flow.
 */
export const Route = createFileRoute('/csat/$token')({
  component: CsatRouteComponent,
});

// eslint-disable-next-line react-refresh/only-export-components
function CsatRouteComponent() {
  const { token } = Route.useParams();
  return <CsatSurveyPage token={token} />;
}
